export { default as SalesContractSlot } from './SalesContractSlot';
